import React from 'react';
import uuidv4 from 'uuid/v4';
import gql from 'graphql-tag';
import client from '../../../utils/apolloClient';

const searchUserLoginHistory = gql`
  query searchUserLoginHistory(
    $placeId: String
    $sort: String
    $from: Int
    $size: Int
  ) {
    search_user_login_history(
      input: {
        filter: {
          user_filter: { app_type: "PARTNER_APP" }
          place_filter: { place_id: [$placeId] }
        }
        sort: $sort
        from: $from
        size: $size
      }
    ) {
      total_pages
      total_size
      user_login_history {
        logged_in
        login_at
        last_login
        user_type
        login_type
        app_type
        version_number
        build_number
        platform
        web_browser
        device_name
        model_number
        ip_address
        unique_id
        user_id
        email
        first_name
        last_name
        android_version
        power_on_or_not
        internet_on_or_not
        place_id
        printer_status
        orders_displayed

        display_new_order_notification_for_auto_confirm
        display_new_order_notification_for_all_venues
        play_new_order_sound_for_all_venues
        print_new_order_for_all_venues
        print_on_order_confirmation
        print_on_order_received
        print_special_characters

        sound_preference_value
      }
    }
  }
`;

export const fetchUserLoginHistory = async ({ placeId, sort, from, size }) => {
  try {
    const data = await client.clientPrivate.query({
      client: client.clientPrivate,
      query: searchUserLoginHistory,
      variables: { placeId, sort, from, size },
      fetchPolicy: 'network-only',
    });
    if (data && data.data && data.data.search_user_login_history) {
      return data.data.search_user_login_history;
    }
    return null;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const fetchStripeBlockUserQuery = gql`
  query fetchStripeBlockUserQuery($stripeBlockUserId: String) {
    fetch_stripe_block_users(input: { user_id: $stripeBlockUserId }) {
      device_id
      payment_method_id
      stripe_block_user_id
      user_id
    }
  }
`;

export const fetchStripeBlockUser = async ({ stripeBlockUserId }) => {
  try {
    const data = await client.clientPrivate.query({
      client: client.clientPrivate,
      query: fetchStripeBlockUserQuery,
      variables: {
        stripeBlockUserId,
      },
      fetchPolicy: 'network-only',
    });

    if (data && data?.data?.fetch_stripe_block_users) {
      return data?.data?.fetch_stripe_block_users;
    }
    return null;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const useStripeBlockUser = ({ stripeBlockUserId }) => {
  const [loading, setLoading] = React.useState(true);
  const [stripeBlockUser, setStripeBlockUser] = React.useState(null);

  const [reload, setReload] = React.useState(uuidv4());

  const refreshDataFunc = () => setReload(uuidv4());

  React.useEffect(() => {
    const fetchFunc = async () => {
      setLoading(true);
      setStripeBlockUser(null);

      if (stripeBlockUserId) {
        const res = await fetchStripeBlockUser({ stripeBlockUserId });

        if (res) {
          setStripeBlockUser(res);
        } else {
          // pass
        }
      }
      setLoading(false);
    };

    fetchFunc();
  }, [stripeBlockUserId, reload]);

  return [loading, stripeBlockUser, refreshDataFunc];
};

const createStripeBlockUsersMutation = gql`
  mutation createStripeBlockUsersMutation(
    $stripeBlockUserId: String
    $userId: String
    $isBlocked: Boolean
    $deviceId: String
  ) {
    create_stripe_block_users(
      input: {
        stripe_block_user_id: $stripeBlockUserId
        user_id: $userId
        is_blocked: $isBlocked
        device_id: $deviceId
      }
    ) {
      device_id
      payment_method_id
      stripe_block_user_id
      user_id
    }
  }
`;

const updateStripeBlockUsersMutation = gql`
  mutation updateStripeBlockUsersMutation(
    $stripeBlockUserId: String
    $userId: String
    $isBlocked: Boolean
    $deviceId: String
  ) {
    update_stripe_block_users(
      input: {
        stripe_block_user_id: $stripeBlockUserId
        user_id: $userId
        is_blocked: $isBlocked
        device_id: $deviceId
      }
    ) {
      device_id
      payment_method_id
      stripe_block_user_id
      user_id
    }
  }
`;

const deleteStripeBlockUsersMutation = gql`
  mutation deleteStripeBlockUsersMutation(
    $stripeBlockUserId: String
    $deviceId: String
  ) {
    delete_stripe_block_users(
      input: { stripe_block_user_id: $stripeBlockUserId, device_id: $deviceId }
    ) {
      device_id
      payment_method_id
      stripe_block_user_id
      user_id
    }
  }
`;

const mutateBlockUser = async ({ input, mutation }) => {
  try {
    await client.clientPrivate.mutate({
      client: client.clientPrivate,
      mutation,
      variables: {
        ...input,
      },
    });
    // pass
  } catch {
    // pass
  }
};

export const onUpdateStripeBlockUser = async ({
  stripeBlockUserId,
  userId,
  isSelected,
  isUpdate,
  refreshData,
  deviceId,
}) => {
  if (isUpdate && isSelected) {
    await mutateBlockUser({
      input: {
        stripeBlockUserId,
        userId,
        isBlocked: isSelected,
        deviceId,
      },
      mutation: updateStripeBlockUsersMutation,
    });
    refreshData();
  } else if (isUpdate && !isSelected) {
    await mutateBlockUser({
      input: { stripeBlockUserId, deviceId },
      mutation: deleteStripeBlockUsersMutation,
    });
    refreshData();
  } else if (!isUpdate && isSelected) {
    await mutateBlockUser({
      input: {
        stripeBlockUserId,
        userId,
        isBlocked: isSelected,
        deviceId,
      },
      mutation: createStripeBlockUsersMutation,
    });
    refreshData();
  } else if (!isUpdate && !isSelected) {
    // pass
  } else {
    // pass
  }
};

export default {};
